module.exports = __webpack_public_path__ + "static/media/confirm_man.05354bb3.png";